<div>
  <div *ngIf="showHeader">
    <div class="text-lg text-black font-bold mb-7">Addresses</div>
  </div>
  <div-content
    [ngClass]="{
      '!px-0': !showHeader
    }"
  >
    <form
      [formGroup]="addressForm"
      class="address-content-layout"
      [class.disabled]="sameAsCompany"
    >
      <!--      <ng-container *ngFor="let address of companyAddresses.CompanyAddressAddresses">-->
      <mat-form-field>
        <mat-label>Street Address</mat-label>
        <input
          matInput
          formControlName="streetAddress"
          type="text"
          name="street-address"
          [readonly]="keepDisableSaveBtn"
        />
        <mat-error>Street Address is required</mat-error>
      </mat-form-field>
      <mat-form-field>
        <mat-label>Suite / Apartment</mat-label>
        <input
          matInput
          formControlName="suiteApartment"
          type="text"
          name="suite-apartment"
          [readonly]="keepDisableSaveBtn"
        />
      </mat-form-field>

      <mat-form-field>
        <mat-label>Country</mat-label>
        <mat-select
          formControlName="country"
          name="country"
          [disabled]="keepDisableSaveBtn"
        >
          <mat-option
            *ngFor="let country of countries?.businessCodes"
            [value]="country.name"
            >{{ country.description }}</mat-option
          >
        </mat-select>
      </mat-form-field>

      <!-- <mat-form-field>
        <mat-label>State / Province</mat-label>
        <mat-select formControlName="stateProvince" name="state-province" [disabled]="keepDisableSaveBtn">
          <mat-option *ngFor="let state of states?.businessCodes" [value]="state.name">{{ state.description
            }}</mat-option>
        </mat-select>
      </mat-form-field> -->

      <mat-form-field class="dashboard-date-picker" appearance="outline">
        <mat-label>State / Province</mat-label>
        <input
          [matAutocomplete]="auto"
          formControlName="stateProvince"
          name="state-province"
          matInput
          type="text"
          [disabled]="keepDisableSaveBtn"
        />
        <mat-autocomplete #auto="matAutocomplete">
          <mat-option
            *ngFor="let state of filteredOptions$ | async"
            [value]="state.name"
          >
            {{ state.description }}
          </mat-option>
        </mat-autocomplete>
      </mat-form-field>

      <mat-form-field>
        <mat-label>City</mat-label>
        <input
          matInput
          formControlName="city"
          type="text"
          name="city"
          [readonly]="keepDisableSaveBtn"
        />
        <mat-error>City is required</mat-error>
      </mat-form-field>

      <mat-form-field>
        <mat-label>Zip / Postal Code</mat-label>
        <input
          matInput
          formControlName="postalCode"
          type="text"
          name="postal-code"
          [readonly]="keepDisableSaveBtn"
        />
        <mat-error>Zip / Postal Code is required</mat-error>
      </mat-form-field>

      <!-- </ng-container> -->
    </form>
  </div-content>
  <div class="flex flex-col sm:flex-row gap-3 sm:gap-4 mt-3">
    <div
      *ngIf="
        sameAsCompany !== undefined &&
        companyAddresses.length &&
        editPermission === true
      "
      class="flex-1 sm:flex-none self-center"
    >
      <tix-checkbox
        [disabled]="isDisabled"
        [checked]="sameAsCompany!"
        (change)="checkSameAsCompany($event)"
        [labelPosition]="'before'"
      >
        Is the Address the same as the Company Address?
      </tix-checkbox>
    </div>

    <div
      class="flex flex-col sm:flex-row gap-3 sm:gap-4 sm:ml-auto justify-end"
    >
      <button
        mat-stroked-button
        class="w-full sm:w-auto px-6 py-1.5 sm:py-1 text-sm font-medium border border-primary text-primary hover:bg-primary-50 order-2 sm:order-1"
        *ngIf="showSkipButton"
        (click)="skipThisCard()"
      >
        Skip
      </button>

      <button
        mat-button
        *ngIf="editPermission === true"
        (click)="onSave()"
        class="w-full sm:w-auto min-w-[160px] px-6 py-1.5 sm:py-1 bg-primary text-white font-medium order-1 sm:order-2"
        [ngClass]="[
          !canSave ? 'cursor-not-allowed' : 'cursor-pointer',
          !canSave && !isloading
            ? 'hover:bg-gray-300 hover:text-gray-700 hover:opacity-50'
            : 'hover:bg-primary-700'
        ]"
        [disabled]="!canSave"
      >
        <div *ngIf="!isloading" class="flex items-center justify-center">
          <span class="material-icons-outlined mr-2 text-lg">save</span>
          <span>Save Changes</span>
        </div>
        <div
          *ngIf="isloading"
          class="flex items-center justify-center space-x-2"
        >
          <span class="mr-2" *tixBtnLoading="isloading"></span>
          <span>Loading</span>
        </div>
      </button>
    </div>
  </div>
</div>
